import { Link } from 'react-router-dom';
import { products } from '../../mocks/products';

export default function HomePage() {
  const featuredProducts = products.slice(0, 4);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e8427f15d97a6b31765fe2ce93522e1c.jpg"
            alt="ELL'ZEN Beauty"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Révélez votre beauté naturelle
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 md:mb-8 text-white/95 px-4">
            Découvrez notre collection exclusive de <strong>parfums Chogan, cosmétiques naturels </strong>et<strong> bijoux artisanaux</strong>
          </p>
          <Link
            to="/produits"
            className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-8 md:px-10 py-3 md:py-4 rounded-lg text-sm sm:text-base md:text-lg font-medium transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Découvrir nos produits
          </Link>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Produits en vedette
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 px-4">
              Nos <strong>produits de beauté</strong> les plus populaires
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8" data-product-shop>
            {featuredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-gray-50 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all"
              >
                <div className="w-full h-56 md:h-72 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-3 sm:p-4 md:p-5">
                  <span className="text-xs font-medium text-teal-600 bg-teal-50 px-2 md:px-3 py-1 rounded-full">
                    {product.category}
                  </span>
                  <h3 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mt-2 mb-1 md:mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 line-clamp-2">
                    {product.description}
                  </p>
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-lg sm:text-xl md:text-2xl font-bold text-teal-600">
                      €{product.price.toFixed(2)}
                    </span>
                    <Link
                      to="/produits"
                      className="bg-teal-600 hover:bg-teal-700 text-white px-3 md:px-4 py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                    >
                      Voir détails
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 md:mt-12">
            <Link
              to="/produits"
              className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-6 sm:px-8 md:px-10 py-3 md:py-4 rounded-lg text-sm sm:text-base md:text-lg font-medium transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Voir tous les produits
            </Link>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Nos catégories
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 px-4">
              Explorez notre gamme complète de <strong>produits de beauté</strong>
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {[
              {
                name: 'Parfums',
                image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20perfume%20bottles%20arranged%20on%20a%20minimalist%20white%20marble%20surface%20with%20soft%20natural%20lighting%20and%20delicate%20flower%20petals%20creating%20a%20sophisticated%20and%20refined%20atmosphere%20emphasizing%20premium%20fragrance%20collection%20in%20modern%20aesthetic%20style&width=600&height=800&seq=cat-parfums-001&orientation=portrait',
                count: products.filter(p => p.category === 'Parfums').length,
              },
              {
                name: 'Corps et Hygiène',
                image: 'https://readdy.ai/api/search-image?query=Natural%20body%20care%20and%20hygiene%20products%20including%20soaps%20and%20lotions%20arranged%20on%20a%20clean%20white%20background%20with%20fresh%20botanical%20elements%20and%20soft%20lighting%20creating%20a%20pure%20and%20refreshing%20atmosphere%20in%20minimalist%20modern%20style&width=600&height=800&seq=cat-corps-001&orientation=portrait',
                count: products.filter(p => p.category === 'Corps et Hygiène').length,
              },
              {
                name: 'Soins du Visage',
                image: 'https://readdy.ai/api/search-image?query=Premium%20facial%20skincare%20products%20and%20serums%20displayed%20on%20a%20soft%20pastel%20background%20with%20natural%20botanical%20ingredients%20and%20gentle%20lighting%20emphasizing%20skin%20care%20and%20beauty%20treatment%20in%20elegant%20modern%20aesthetic&width=600&height=800&seq=cat-visage-001&orientation=portrait',
                count: products.filter(p => p.category === 'Soins du Visage').length,
              },
              {
                name: 'Soins Capillaires',
                image: 'https://readdy.ai/api/search-image?query=Natural%20hair%20care%20products%20and%20treatments%20arranged%20on%20a%20minimalist%20white%20surface%20with%20botanical%20elements%20and%20soft%20natural%20lighting%20creating%20a%20fresh%20and%20healthy%20atmosphere%20emphasizing%20hair%20beauty%20in%20modern%20style&width=600&height=800&seq=cat-cheveux-001&orientation=portrait',
                count: products.filter(p => p.category === 'Soins Capillaires').length,
              },
            ].map((category) => (
              <Link
                key={category.name}
                to="/produits"
                className="group relative h-56 sm:h-64 md:h-80 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all cursor-pointer"
              >
                <div className="w-full h-full">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 text-white">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-1 md:mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {category.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-white/90">
                    {category.count} produits
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Prête à transformer votre routine beauté ?
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 md:mb-8 text-white/95 px-4">
            Découvrez nos <strong>produits de beauté</strong> exceptionnels et commencez votre voyage vers une peau radieuse
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/produits"
              className="w-full sm:w-auto bg-white text-teal-600 hover:bg-gray-100 px-6 sm:px-8 md:px-10 py-3 md:py-4 rounded-lg text-sm sm:text-base md:text-lg font-medium transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Voir les produits
            </Link>
            <Link
              to="/contact"
              className="w-full sm:w-auto bg-teal-700 hover:bg-teal-800 text-white px-6 sm:px-8 md:px-10 py-3 md:py-4 rounded-lg text-sm sm:text-base md:text-lg font-medium transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              Nous contacter
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
